import React from 'react';
import { BaseUnmetDemandSystemSection } from './BaseUnmetDemandSystemSection';
import WaterIcon from '@mui/icons-material/Water';
import { useTheme } from '@mui/material/styles';

// --- MODIFIED: Added scenarioName and hazardLabel to props ---
export const UnmetDemandWaterSystemSection = ({
    analysisData,
    nameMap,
    floodData,
    scenarioId,
    llmSummaries,
    scenarioName,
    hazardLabel
}) => {
    const theme = useTheme();
    const systemLabel = "Water Supply";

    return (
        <BaseUnmetDemandSystemSection
            analysisData={analysisData}
            nameMap={nameMap}
            systemKey="water"
            sectionTitle={`${systemLabel} system infrastructures with demand shortage risks`}
            systemIcon={WaterIcon}
            systemColor={theme.palette.info.main}
            floodData={floodData}
            scenarioId={scenarioId}
            // --- MODIFIED: Pass the new props down ---
            scenarioName={scenarioName}
            hazardLabel={hazardLabel}
            // --- FIXED: Changed prop name from llmSummary to the expected llmInsights ---
            llmInsights={llmSummaries?.systems?.water}
        />
    );
};